<template>
  <section class="home">
    <carousel 
      ref="carousel"
      class="key-visual-slider"
      :per-page="1"
      :loop="true"
      :speed="1500"
      :autoplay-timeout="5500"
      :autoplay-hover-pause="false"
      :scroll-per-page="false"
      :navigation-enabled="false"
      :pagination-enabled="true"
      :autoplay="autoplay"
    >
      <slide
        v-for="(slide, index) in slides"
        :key="index"
        :class="['slide-item', `slide-item${index + 1}`]"
      >
        <div class="image-slide">
          <div class="container" :class="{'fade-in-down': currentSlide === index}" >
            <span class="service-name">{{ slide.serviceName }}</span>
            <p class="title" v-html="slide.title"></p>
            <p class="desc" v-if="slide.desc">{{ slide.desc }}</p>
          </div>
        </div>
      </slide>
    </carousel>
    <div class="slider-control">
      <button type="button" class="btn btn-pause" v-if="autoplay" @click="pause">Pause</button>
      <button type="button" class="btn btn-play" v-if="!autoplay" @click="play">Play</button>
    </div>
    <button class="btn-section-mouse" title="다음으로 이동" @click="buttonMouse">
      <img class="section-mouse" src="../../assets/partners_pc/img_mouse_arrow.png" alt="">
      <img class="mouse-arrow" src="../../assets/partners_pc/img_chevron_down.png" alt="">
    </button>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      autoplay: true,
      currentSlide: null,
      slides: [
        {
          serviceName: '바로돌봄',
          title: '국내 유일<br> 의료취약계층을 위한<br> <span class="text-primary">비대면진료 서비스</span>',
          desc: '의료취약계층 : 어르신, 장애인, 섬벽지거주자 등'
        },
        {
          serviceName: '비대면진료',
          title: '언제, 어디서나<br> 쉽고 안전하게<br> <span class="text-primary">의사를 만나보세요</span>',
          desc: ''
        },
        {
          serviceName: '약 배송',
          title: '약 배달 서비스로<br> 계신 곳에서 편하게<br> <span class="text-primary">약을 받아보세요</span>',
          desc: ''
        }
      ],
    };
  },
  methods: {
    pause() {
      this.autoplay = false;
      this.$refs.carousel.pauseAutoplay();
    },
    play() {
      this.autoplay = true;
      this.$refs.carousel.startAutoplay();
    },

    buttonMouse() {
      let height = window.scrollY;
      let oneVhHeight = window.innerHeight;

      if (height < oneVhHeight) {
        this.scrollToPosition(oneVhHeight);
      }
  },

    scrollToPosition(position) {
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    },
  },
  mounted() {
    this.$nextTick(() => {// 초기 로딩 시 항상 첫 번째 슬라이드를 활성화
      this.currentSlide = 0; // 첫 번째 슬라이드를 활성화합니다.
      this.$refs.carousel.$on('input', (newIndex) => {
        this.currentSlide = newIndex;
      });
    });
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_new/Home.vue